import { lazy } from "react";

const AllSales = lazy(() => import("../../../pages/User/sales/Sales"));
const AddCredentials = lazy(() => import("../../../pages/User/sales/AddCredentials"));

export const salesRoutes = [
  { path: "sales/:cat", element: <AllSales /> },
  { path: "sales/:cat/:id/add-credentials", element: <AddCredentials /> },
];
